module.exports = __webpack_public_path__ + "9779d9a1/img/copy-icon.408fdb2d.svg";